module.exports = __webpack_public_path__ + "static/media/garlandOptimised.8954afad.png";